import { NavLink as MantineNavLink, NavLinkProps, useMantineTheme } from '@mantine/core';
import { forwardRef } from 'react';

export type GradientVariant =
  | 'primary'
  | 'secondary'
  | 'tertiary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger';

export interface ThemedNavLinkProps extends NavLinkProps {
  gradientActive?: boolean;
  gradientVariant?: GradientVariant;
  customGradient?: string; // Custom gradient CSS string
}

const NavLink = forwardRef<HTMLAnchorElement, ThemedNavLinkProps>(
  ({ gradientActive = false, gradientVariant = 'primary', customGradient, active, styles, ...rest }, ref) => {
    const theme = useMantineTheme();
    const gradient = theme.other.gradients[gradientVariant];

    if (!gradientActive && !customGradient) {
      return <MantineNavLink ref={ref} active={active} styles={styles} {...rest} />;
    }

    // Use custom gradient if provided, otherwise use theme gradient
    const gradientStyle = customGradient || `linear-gradient(135deg, ${gradient.from}, ${gradient.to})`;

    return (
      <MantineNavLink
        ref={ref}
        active={active}
        styles={{
          ...styles,
          root: {
            '&[data-active]': {
              backgroundImage: gradientStyle,
              color: 'white',
              '&:hover': {
                backgroundImage: gradientStyle,
              },
            },
            ...(styles as any)?.root,
          },
        }}
        {...rest}
      />
    );
  }
);

NavLink.displayName = 'NavLink';

export default NavLink;
